import { Grid } from "react-feather"
import { ACL_READ, ACL_SUBJECT_APPLICATION } from "@configs/acl/constants"

export default [
    {
        id: "application",
        title: "Application",
        icon: <Grid />,
        children: [
            {
                id: "service-cyberlotus",
                title: "applicationCyberlotus",
                icon: <Grid />,
                navLink: "/application-cyberlotus",
                action: ACL_READ,
                resource: ACL_SUBJECT_APPLICATION
            },
            {
                id: "service",
                title: "service",
                icon: <Grid />,
                navLink: "/application",
                action: ACL_READ,
                resource: ACL_SUBJECT_APPLICATION
            },
            {
                id: "requestPartner",
                title: "requestPartner",
                icon: <Grid />,
                navLink: "/request-partner",
                action: ACL_READ,
                resource: ACL_SUBJECT_APPLICATION
            }
        ]
    }
]
